import React from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./Footer";

const TermsConditions: React.FC = () => {
  return (
    <div>
      <Box sx={{ padding: "60px 40px", backgroundColor: "#f9f9f9", color: "#000", minHeight: "80vh" }}>
        <Typography variant="h4" fontWeight="bold" mb={4} align="center">
          Terms and Conditions
        </Typography>

        <Typography variant="body1" paragraph>
          These Terms and Conditions govern your use of our website and services. By accessing or using our services, you agree to be bound by these terms.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1" paragraph>
          By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          2. Services
        </Typography>
        <Typography variant="body1" paragraph>
          Our company provides professional services to assist clients with various financial and legal matters. We act based on information provided by clients and maintain professional standards in all our dealings.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          3. Privacy and Confidentiality
        </Typography>
        <Typography variant="body1" paragraph>
          We maintain strict confidentiality regarding all personal and financial information shared with us. Your privacy is important to us, and we are committed to protecting your personal data.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          4. Intellectual Property Rights
        </Typography>
        <Typography variant="body1" paragraph>
          All content, materials, and information on this website are protected by intellectual property rights. You may not reproduce, distribute, or use any content without prior written permission.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          5. User Responsibilities
        </Typography>
        <Typography variant="body1" paragraph>
          Users are responsible for providing accurate information and using our services in accordance with applicable laws and regulations. Any misuse of our services may result in termination of access.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          6. Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph>
          Our liability is limited to the extent permitted by law. We shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          7. Modifications to Terms
        </Typography>
        <Typography variant="body1" paragraph>
          We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting on this website. Continued use of our services constitutes acceptance of modified terms.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          8. Governing Law
        </Typography>
        <Typography variant="body1" paragraph>
          These Terms and Conditions are governed by the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the competent courts.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          9. Contact Information
        </Typography>
        <Typography variant="body1" paragraph>
          For any questions or concerns regarding these Terms and Conditions, please contact us through the contact information provided on our website.
        </Typography>

      </Box>
    </div>
  );
};

export default TermsConditions;
